<template>
  <v-layout column class="fill-height">
    <Diccionario :id_unit="this.idUnidad"/>
    <HeaderFill 
      :title="`Lección ${currentLesson.name_lesson}`" 
      :back="false" 
      :router="`/gramatica/${this.idUnidad}/${this.idGrammar}/gramaticaDash`"/>
    <v-progress-linear 
      :value="progress" 
      color="yellow" height="5" class="e-progress"></v-progress-linear>
    <v-flex xs12 style="position: relative;">
      <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
      <carousel 
        v-if="!loading"
        :responsive="carouselProperty" 
        :loop="false" 
        :items="1" 
        :margin="10" 
        :center="true" 
        class="e-carousel--unidad leccion" 
        @changed="avanzarLeccion">
        <!-- aqui va la descripción de la leccion -->
        <LeccionInicio :descripcion="currentLesson.description"/>
        <!-- mirar si aplica -->
        <!-- LeccionIntro /-->
        <div v-for="lesson in loadedLessonDetails" :key="`div-lesson-${lesson.id_det_leccion}`">
          <!-- si no tiene imagenes es de texto pero el titulo no debe ser Ejemplo-->
          <LeccionTexto 
            v-if="lesson.image.length === 0 && lesson.title !== 'Ejemplo'"
            :subtema="lesson.title"
            :text1="lesson.description"
          />
          <!-- se utiliza cuando se tiene una imagen -->
          <LeccionImage
            v-if="lesson.image.length > 0"
            :subtema="lesson.title"
            :image="lesson.image"
            :description="lesson.description"
          />
          <!-- se utiliza cuando el titulo es Ejemplo -->
          <LeccionEjemplo
            v-if="lesson.title === 'Ejemplo'"
            :subtema="lesson.title"
            :descripcionKr="lesson.description"
          />
        </div>
        <LeccionFinal 
          :id_unit="this.idUnidad" 
          :id_grammar="this.idGrammar"
          :grammaIsFull="this.grammaIsFull"
          :leccion="currentLesson.name_lesson"/>
      </carousel>
    </v-flex>
  </v-layout>
</template>

<script>
import LeccionInicio from '../../components/Gramatica/Leccion/carousel/LeccionInicio'
import LeccionIntro from '../../components/Gramatica/Leccion/carousel/LeccionIntro'
import LeccionImage from '../../components/Gramatica/Leccion/carousel/LeccionImage'
import LeccionTexto from '../../components/Gramatica/Leccion/carousel/LeccionTexto'
import LeccionEjemplo from '../../components/Gramatica/Leccion/carousel/Leccionejemplo'
import LeccionFinal from '../../components/Gramatica/Leccion/carousel/LeccionFinal'
import { storeFirebase } from '../../store/firebase'

export default {
  name: 'Leccion',
  components: {
    LeccionFinal,
    LeccionInicio,
    LeccionIntro,
    LeccionEjemplo,
    LeccionImage,
    LeccionTexto
  },
  props: ['idUnidad','idGrammar','idLesson'],
  data () {
    return {
      progress: 0,
      numberLessons: 0,
      loading: true,
      carouselProperty: {
        '0': {
          items: 1,
          nav: false,
          loop: false,
          center: true,
          dots: false
        },
        '768': {
          items: 3,
          nav: false,
          loop: false,
          center: true,
          dots: true
        }
      },
      grammaIsFull: false,
      progressUser: {}
    }
  },
  created () {
    this.loadLessons()
  },
  computed: {
    currentLesson () {
      const lessons = storeFirebase.getters.loadedLessons
      const lesson = lessons.find(lesson => lesson.id_lesson == this.idLesson)
      if (lesson == null && lesson == undefined) {
        lesson = {
          name_lesson: '',
          description: ''
        }
      }
      return lesson
    },
    loadedLessonDetails () {
      const lessons = storeFirebase.getters.loadedLessonDetails
      this.numberLessons = lessons.length + 1
      return lessons
    }
  },
  methods: {
    loadLessons () {
      const payload = {
        id_grammar:  Number(this.idGrammar),
        id_lesson:  Number(this.idLesson)
      }
      this.progressUser = storeFirebase.getters.userProgress
      storeFirebase.dispatch("loadLessonDetails", payload).then(() => {
        setTimeout(() => {
          this.loading = false
        }, 2500)
      })
    },
    avanzarLeccion (changed) {
      const currentProgress = this.progress = (100 / this.numberLessons) * changed.item.index
      if(currentProgress === 100){
        this.sumarLesson()
      }
      return currentProgress
    },
    sumarLesson() {
      const unitVal = 'unit_' + this.idUnidad
      const progressGrammar = this.progressUser.grammar[unitVal]
      const gramVal = 'grammar_' + this.idGrammar
      let progressLesson = {
        lessonsIsFull: true
      }
      for(let index in progressGrammar) {
        const data = progressGrammar[index]
        for(let value in data){
          if(value === gramVal) {
            progressLesson = data
            break
          }
        }
      }
      const lessVal = 'lesson_' + this.idLesson
      progressLesson[lessVal] = 100
      let sumaValLesson = 0
      for(let index in progressLesson) {
        if(index.includes('lesson_')) {
          const value = progressLesson[index];
          sumaValLesson = sumaValLesson + value
        }
      }
      const totalLesson = progressLesson.totalLesson
      const totalGrammar = sumaValLesson / totalLesson
      progressLesson[gramVal] = totalGrammar
      if(totalGrammar === 100) {
        this.grammaIsFull = true
      }
      this.updateUserProgress(this.progressUser)
    },
    updateUserProgress(newUserProgress) {
      storeFirebase.dispatch('updateUserProgress', newUserProgress)
    }
  }
}
</script>
